export const SITE_METADATA = {
  title: 'Lumora: The First Dawn',
  description:
    'Lumora is an upcoming story-driven RPG about emerging magic in a world that has never known such power. Track the development, explore the world, and stay connected with the community.',
  url: 'https://www.lumoragame.com',
  locale: 'en_US',
};

export type SeoInput = {
  title?: string;
  description?: string;
  image?: string;
  article?: boolean;
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  tags?: string[];
  noindex?: boolean;
  canonical?: string;
};
